import { useMemo } from 'react'
import { PlugConnected24Regular } from '@/components/Icon'
import useConnectedToolkits from '@/hooks/useConnectedToolkits'
import { CONNECTION_APP_META_BY_SLUG } from './aiAskBarLayoutConstants'

export function useAiAskBarConnections() {
  const connectedToolkitSlugs = useConnectedToolkits()

  const connectedApps = useMemo(() => {
    return connectedToolkitSlugs.map((slug) => {
      const key = String(slug || '').toLowerCase()
      const meta = CONNECTION_APP_META_BY_SLUG.get(key)
      return {
        slug: key,
        title: meta?.title || key.replace(/[-_]+/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase()),
      }
    })
  }, [connectedToolkitSlugs])

  const connectedAppsMenuItems = useMemo(() => {
    const appItems = connectedApps.map((app) => ({
      id: `connected-app-${app.slug}`,
      label: app.title,
      Icon: PlugConnected24Regular,
    }))
    if (appItems.length === 0) {
      appItems.push({
        id: 'connected-app-empty',
        label: 'No connected apps yet',
        Icon: PlugConnected24Regular,
      })
    }
    appItems.push({
      id: 'connected-app-manage',
      label: 'Manage connections',
      Icon: PlugConnected24Regular,
      showDividerBefore: true,
    })
    return appItems
  }, [connectedApps])

  return { connectedApps, connectedAppsMenuItems }
}
